import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { AssigneeNote } from '@backrs_ui/grow-ui/src/redux/coachingDashboard/coachingDashboard.types';

const PREVIEW_LENGTH = 200;

const truncate = (text: string, max: number): string =>
  text.length <= max ? text : `${text.slice(0, max).trimEnd()}…`;

export const useAgentContext = (notes: readonly AssigneeNote[]) => {
  useRegisterAgentContext({
    kind: 'list',
    description:
      'Coach-authored notes about this student, visible on the Notes tab of the coaching dashboard. Each entry includes only a short plaintext preview of the note body, not the full text.',
    data: notes.map((note) => ({
      id: note.id,
      created_at: note.created_at,
      updated_at: note.updated_at,
      preview: truncate(note.body_plaintext, PREVIEW_LENGTH),
    })),
  });
};
